import React from 'react';
import { User, Building, Phone, Mail, Briefcase, MapPin } from 'lucide-react';
import InputField from './common/InputField';

const RupeeIcon = ({ className }) => (
    <span className={`${className} font-bold leading-none flex items-center`}>₹</span>
);

const InvestorFields = ({ handleInputChange, errors = {}, formData = {} }) => {
    return (
        <>
            {/* Investor Type Radio Buttons */}
            <div className={`w-full p-4 flex flex-col justify-center text-left hover:bg-gray-50 transition-colors rounded-xl ${errors.investorType ? 'bg-red-50/50' : ''}`}>
                <label className={`text-[10px] font-bold uppercase tracking-wider mb-2 px-1 ${errors.investorType ? 'text-red-500' : 'text-gray-400'}`}>
                    Investor Type <span className="text-red-500">*</span> {errors.investorType && <span className="lowercase font-medium ml-2">({errors.investorType})</span>}
                </label>
                <div className="flex items-center gap-6 px-1">
                    <label className="flex items-center cursor-pointer group">
                        <input
                            type="radio"
                            name="investorType"
                            value="Individual"
                            checked={formData.investorType === 'Individual'}
                            onChange={handleInputChange}
                            className="hidden"
                        />
                        <div className={`w-4 h-4 rounded-full border-2 mr-2 flex items-center justify-center transition-all ${formData.investorType === 'Individual' ? 'border-primary bg-primary' : 'border-gray-300'}`}>
                            {formData.investorType === 'Individual' && <div className="w-1.5 h-1.5 rounded-full bg-white" />}
                        </div>
                        <span className={`text-sm font-medium ${formData.investorType === 'Individual' ? 'text-primary' : 'text-gray-500 group-hover:text-primary'}`}>Individual</span>
                    </label>
                    <label className="flex items-center cursor-pointer group">
                        <input
                            type="radio"
                            name="investorType"
                            value="Institutional"
                            checked={formData.investorType === 'Institutional'}
                            onChange={handleInputChange}
                            className="hidden"
                        />
                        <div className={`w-4 h-4 rounded-full border-2 mr-2 flex items-center justify-center transition-all ${formData.investorType === 'Institutional' ? 'border-primary bg-primary' : 'border-gray-300'}`}>
                            {formData.investorType === 'Institutional' && <div className="w-1.5 h-1.5 rounded-full bg-white" />}
                        </div>
                        <span className={`text-sm font-medium ${formData.investorType === 'Institutional' ? 'text-primary' : 'text-gray-500 group-hover:text-primary'}`}>Institutional</span>
                    </label>
                </div>
            </div>

            <InputField
                label={formData.investorType === 'Institutional' ? 'Institution Name' : 'Full Name'}
                name="name"
                placeholder={formData.investorType === 'Institutional' ? "Enter institution name" : "Enter your full name"}
                icon={formData.investorType === 'Institutional' ? Building : User}
                required
                error={errors.name}
                onChange={handleInputChange}
                value={formData.name || ''}
            />

            <div className="flex flex-col sm:flex-row divide-y sm:divide-y-0 sm:divide-x divide-gray-100">
                <InputField
                    label="Contact"
                    name="contact"
                    type="tel"
                    placeholder="Phone Number"
                    icon={Phone}
                    required
                    error={errors.contact}
                    onChange={handleInputChange}
                    value={formData.contact || ''}
                />

                <InputField
                    label="Email Id"
                    name="email"
                    type="email"
                    placeholder="Email Address"
                    icon={Mail}
                    required
                    error={errors.email}
                    onChange={handleInputChange}
                    value={formData.email || ''}
                />
            </div>

            <div className="flex flex-col sm:flex-row divide-y sm:divide-y-0 sm:divide-x divide-gray-100">
                <InputField
                    label="Investment Capacity"
                    name="investmentCapacity"
                    placeholder="e.g. 1Cr - 5Cr"
                    icon={RupeeIcon}
                    onChange={handleInputChange}
                    value={formData.investmentCapacity || ''}
                />

                <InputField
                    label="Preferred Segment"
                    name="segment"
                    placeholder="e.g. Residential, Commercial"
                    icon={Briefcase}
                    onChange={handleInputChange}
                    value={formData.segment || ''}
                />
            </div>

            <InputField
                label="Location of Interest"
                name="locationOfInterest"
                placeholder="City or Region"
                icon={MapPin}
                onChange={handleInputChange}
                value={formData.locationOfInterest || ''}
            />
        </>
    );
};

export default InvestorFields;

